import { createStateSelectorHook } from 'src/lib/sweetState';
import { useBenchmarkDebounced } from 'src/services';
import { SOURCE } from 'src/data/benchmark';
import { MainStore } from '../../../../../store/main';

const useMainState = createStateSelectorHook(MainStore, ['shareDocumentId']);

export const useBenchmarkConfigProps = ({ benchmarkConfig, id, assetType, copyText }) => {
  const { shareDocumentId } = useMainState();

  const { benchmarkConfig: newBenchmarkConfig, loadingBenchmark } = useBenchmarkDebounced(
    {
      projectId: shareDocumentId,
      assetType,
      text: copyText,
      adAccountId: benchmarkConfig?.account?.id,
      userGoal: benchmarkConfig?.userGoal,
      variationId: id,
    },
    {
      disabled: !benchmarkConfig?.account, // Do not send requests if panel is blocked for any reason
      debounceTimeout: 500,
    }
  );

  return {
    benchmarkConfig: { ...benchmarkConfig, ...newBenchmarkConfig },
    loadingBenchmark,
    counter: copyText?.length,
    source: SOURCE.sharedPage,
  };
};
